import React from 'react';
import $ from 'jquery';
import {CurrencyRenderer, CurrencyRendererRed, NumberRenderer, GetParams, DisplayTimeEnd, DisplayTimeRange, MWBaseURL, GetESTDateString} from './../Utilities.js'
import {createApiClient} from "../api/ApiClient";

class TopSymbolTbl extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			date: null,
			start: null,
			end: null,
			firm: null,
			acct: null,
			sybl: null,

			needToUpdate: false,
			startTS: null,
			endTS: null,
			updateCount: 0
		};

		this.table = null
		this.symbolcontroller = new AbortController()
	}

	static getDerivedStateFromProps(props, state) {
		let obj = {}
		if(state.date !== props.date || state.start !== props.start || state.end !== props.end || state.firm !== props.firm
			|| state.acct !== props.acct || state.sybl !== props.sybl){
			obj = {...props, needToUpdate: true}
		}
		if(state.startTS !== props.startTS || state.endTS !== props.endTS){
			obj.startTS = props.startTS
			obj.endTS = props.endTS
		}
		if(state.updateCount !== props.updateCount){
			obj.updateCount = props.updateCount
			obj.needToUpdate = true
		}
		return obj;
	}
	
	componentDidUpdate(props, state){
		if(this.state.needToUpdate){
			let self = this
			this.setState({needToUpdate: false}, function(){
				if(self.table !== null){
					self.table.ajax.url(MWBaseURL() + "top_symbols?" + GetParams(self.state)).load()
					self.setEvents()
				}
			})
		}
	}

	setEvents(){
		let self = this
		$("#"+self.state.id+" tbody").off()

		$("#"+self.state.id+" tbody").on("click", "tr .filterable", function(){
			let row = self.table.row(this).data()
			self.state.refilter({
				selectedSybl: [row.symbol],
				lastSelectedTbl: self.state.id
			})
		});

	}
	
	componentWillUnmount(){
		$(".popover").popover('dispose')
    }
	
	async componentDidMount() {
		let self = this
		const apiClient = createApiClient();
		this.table = $('#'+self.state.id).DataTable({
			scrollX: true,
			responsive: true,
			paging: false,
			info: false,
			filter: false,
			ajax: await apiClient.getDataTableAjaxSettings(MWBaseURL()+"top_symbols?"+GetParams(self.state)),
			ordering: false,
			columns: [
				{title: "Symbols", data: "symbol", className: "clickable filterable symbolInfo"},
				{title: "SOD", data: "sodposition", render: NumberRenderer, className: "text-right"},
				{title: "Net P&L", data: "endpnl", render: CurrencyRendererRed, className: "text-right"},
				{title: "MV",  data: "endmv", render: CurrencyRenderer, className: "text-right"},
				{title: "Volume", data: "endvolume", render: NumberRenderer, className: "text-right"},
				{title: "Δ Net P&L", data: "pnl", render: CurrencyRendererRed, className: "text-right"},
				{title: "Δ MV", data: "mv", render: CurrencyRenderer, className: "text-right"}
			]
		});
		self.setEvents()
		this.table.on('preDraw', function(){
			$(".popover").popover('dispose')//doesn't seem to work on table element, so delete all
		}).on('draw.dt', function(){
			$('#'+self.state.id).popover({
				selector: 'td.symbolInfo',
				customClass: "symbolPopover",
				title: () => {
					return this.querySelector(".symbolInfo:hover").innerHTML
				},
				html: true,
				content: () => {
					return `<div class="spinner-border" role="status">
						<span class="sr-only">Loading...</span>
					</div>`
				},
				trigger: 'hover',
				delay: {show: 300}
			})
		});
		$('#'+self.state.id).on('show.bs.popover', function () {
			let hoverElm = this.querySelector(".symbolInfo:hover")
			let sybl = hoverElm.innerHTML
			self.symbolcontroller.abort();
			self.symbolcontroller = new AbortController()

			const apiClient = createApiClient();
			apiClient.post(MWBaseURL()+'symbol_info?'+GetParams(self.state), [{symbol: (sybl.length > 15 ? sybl.slice(0, sybl.length - 15) : sybl), date: GetESTDateString()}], {signal: self.symbolcontroller.signal})
			.then(data => {
				let content = "N/A"
				if(data.length !== 0){
					content = `<div>
					<div class="row"><div class="col text-nowrap"><b>Industry</b></div></div>
					<div class="row"><div class="col">${data[0].Industry}</div></div>
					<div class="row"><div class="col text-nowrap"><b>Subindustry</b></div></div>
					<div class="row"><div class="col">${data[0].Subindustry}</div></div>
					</div>`
					$(hoverElm).data('bs.popover').config.title = data[0].Name
				}
				$(hoverElm).data('bs.popover').config.content = content
				$(hoverElm).data('bs.popover').setContent()
			}).catch(e => console.log(e.message));
		})

	}

	render(){
		return (
			<div>
			<h5>Top/Bottom <a href="/#" onClick={() => this.state.refilter({view: 1, lastSelectedTbl: this.state.id, selectedTag: [], selectedSybl: [], selectedx0: null, selectedx1: null, selectedRows: []})}>Symbols</a></h5>
			<table id={this.state.id} className="display compact nowrap groupedTbl groupedHLTbl" width="100%">
					<thead>
						<tr>
							<th colSpan="1" rowSpan="2"></th>
							<th colSpan="1" rowSpan="2"></th>
							<th className="text-center" colSpan="3"><DisplayTimeEnd end={this.state.end} startTS={this.state.startTS} endTS={this.state.endTS}/></th>
							<th className="text-center verticalTableSeparator" colSpan="2"><DisplayTimeRange start={this.state.start} end={this.state.end} startTS={this.state.startTS} endTS={this.state.endTS}/></th>
						</tr>
						<tr>
							<th></th>
							<th></th>
							<th></th>
							<th></th>
							<th></th>
						</tr>
					</thead>
				</table>
			</div>
		)
	}
}


export default TopSymbolTbl;